import { FC } from 'react';
import {
  BLOCKS,
  MARKS,
  INLINES,
} from '@contentful/rich-text-types';
import cn from 'classnames';

import {
  CommonRichText as Content,
  Icon,
  WebpImage,
} from 'components/Shared/SharedComponents';

import styles from './PredefinedReviews.module.scss';

import { PredefinedReviewInterface } from '../config/declarations';

const parsersConfig = {
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.cardParagraph,
  },
  [INLINES.HYPERLINK]: {
    classNames: cn(styles.cardBodyParagraph, styles.cardBodyParagraphLink),
  },
  [MARKS.BOLD]: {
    classNames: styles.cardTitle,
  },
};

/* Nested component */
const Title = Content;

const iconsArray = new Array(5).fill(1).map((_, i) => i);

/* Main component */
const PredefinedReview: FC<PredefinedReviewInterface> = ({ block, chatImage, starImage }) => {
  const {
    content,
    richTitle,
  } = block;

  return (
    <div className={styles.card}>
      {chatImage && (
        <div className={styles.cardChat}>
          <WebpImage
            image={chatImage}
            className={styles.cardChatImage}
          />
        </div>
      )}
      <div className={styles.cardContent}>
        {starImage && (
          <div className={styles.star}>
            {iconsArray.map((digit) => (
              <Icon
                key={`${digit}-icon`}
                image={starImage}
                className={styles.image}
              />
            ))}
          </div>
        )}
        <Title
          content={richTitle}
          parsersConfig={parsersConfig}
        />
        <Content
          content={content}
          parsersConfig={parsersConfig}
        />
      </div>
    </div>
  );
};

export default PredefinedReview;
